import { legacy_createStore, applyMiddleware } from "redux";
import { routerMiddleware } from "react-router-redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";

import sagas from "store/sagas";
import reducers from "store/ducks";
import { history } from "routes/history";

const sagaMiddleware = createSagaMiddleware();
const routersMiddleware = routerMiddleware(history);
const middleware = [sagaMiddleware, routersMiddleware];

const createAppropriateStore = legacy_createStore

const store = createAppropriateStore(
  reducers,
  composeWithDevTools(applyMiddleware(...middleware))
);

sagaMiddleware.run(sagas);

export default store;
